import { BreezeIntelligenceKitProvider } from 'breeze-intelligence-kit';
import { CurrentUserProvider } from 'policy-lib';
import { EnrichmentCreditsProvider } from '../EnrichmentCreditsProvider/EnrichmentCreditsProvider';
import { EnrichmentSettingsProvider } from '../EnrichmentSettingsProvider';
import { EnrichableObjectTypeProvider } from '../EnrichableObjectTypesProvider';
import { jsx as _jsx } from "react/jsx-runtime";
export function DataTestProvider({
  children
}) {
  return /*#__PURE__*/_jsx(BreezeIntelligenceKitProvider, {
    children: /*#__PURE__*/_jsx(CurrentUserProvider, {
      children: /*#__PURE__*/_jsx(EnrichmentCreditsProvider, {
        children: /*#__PURE__*/_jsx(EnrichmentSettingsProvider, {
          children: /*#__PURE__*/_jsx(EnrichableObjectTypeProvider, {
            children: children
          })
        })
      })
    })
  });
}